module.exports = __webpack_public_path__ + "img/photo-03.d168badd.jpg";